module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sq-loadmore', {
    attrs: {
      "top-method": _vm.topMethod
    }
  }, [_c('sq-timeline', _vm._l((_vm.data), function(item, i) {
    return _c('sq-timeline-item', {
      key: item.CommentID
    }, [(_vm.showDate(i, 'year')) ? _c('div', {
      staticClass: "m-timeline-time--year fz11",
      attrs: {
        "slot": "yeartime"
      },
      slot: "yeartime"
    }, [_vm._v("\n        " + _vm._s(_vm.formateDate(item.CreateTimeToInt, 'year')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        'm-timeline-item': true,
        'm-timeline-item--head': _vm.showDate(i, 'year'),
          'm-timeline-item--notime': !_vm.showDate(i, 'date'),
          'm-timeline-item--tail': i === _vm.data.length - 1 ? true : _vm.showDate(i + 1, 'year'),
          'm-timeline-item--last': i === _vm.data.length - 1
      }
    }, [(_vm.showDate(i, 'date')) ? _c('div', {
      staticClass: "m-timeline-time--day fz12"
    }, [_vm._v("\n          " + _vm._s(_vm.formateDate(item.CreateTimeToInt, 'date')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('sq-card', {
      attrs: {
        "data": item,
        "show-date": _vm.showDate(i, 'date')
      }
    }, [(item.PreCommentInfo) ? _c('sq-card-incard', {
      attrs: {
        "data": item.PreCommentInfo,
        "isInCard": true
      }
    }) : _vm._e()], 1)], 1)])
  }), 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1d9b7ac8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content/live.vue
// module id = 202
// module chunks = 1